<template>
  <div class="resultView">
    <template v-if="results.hits && results.hits.length > 0">
      <div class="resultRow resultRowHeader">
        <div class="header">
          <div class="ce-col ce-col-actionsBefore" />
          <div class="ce-col ce-col-color" />
          <div class="ce-col ce-col-shadeName">
            <span>{{ $t('formulationRepository.searchPage.columns.shadeName') }}</span>
          </div>

          <div class="ce-col ce-col-actionsAfter" />
        </div>
      </div>

      <div>
        <ShadeRow
          v-for="hit in results.hits"
          :key="hit.id"
          :row="hit" />
      </div>

      <div class="my4 flex flex-column items-center">
        <div>
          <button
            v-if="canLoadMore"
            class="ce-btn ce-btn-light"
            :disabled="isLoading"
            @click.prevent="loadMore">
            <template v-if="isLoading">
              <fa-icon
                icon="spinner"
                spin />
            </template>
            <template v-else>
              {{ $t('formulationRepository.searchPage.columns.loadMore') }}
            </template>
          </button>
        </div>

        <div
          v-if="results.hits && results.hits.length > 0"
          class="mt2 ms-2 center">
          <template v-if="canLoadMore">
            {{ $t('generic.resultsHint', { loaded: results.hits.length, total: resultsTotal }) }}
          </template>
          <template v-else>
            {{ $t('generic.resultsHintAllLoaded', { total: resultsTotal }) }}
          </template>
        </div>
      </div>
    </template>

    <div
      class="ms1 bold center"
      v-else>
      <div>
        {{ $t('formulationRepository.searchPage.noResults') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ShadeRow from './ShadeRow.vue';

export default {
  computed: {
    ...mapState('generic', ['links']),
    ...mapState(['isLoading']),
    ...mapGetters(['results', 'activeTab', 'canLoadMore', 'resultsTotal'])
  },
  components: {
    ShadeRow,
  },
  methods: {
    ...mapActions(['loadMore']),
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-formulationRepo .resultRow {
  &.resultRowHeader {
    background: none !important;
    font-weight: bold;
    border-bottom: 2px solid @color-mono-80;

    .header {
      background: none !important;
    }

    .ce-col-shadeName {
      width: 140px !important;
      flex: none !important;
    }
  }

  .ce-col {
    &.ce-col-actionsBefore {
      width: 25px;
      .flex-none;
    }
    &.ce-col-color {
      width: 18px;
      .flex-none;
    }
    &.ce-col-shadeName {
      .flex-auto;
    }
    &.ce-col-formulationName {
      .flex-auto;
    }
    &.ce-col-actionsAfter {
      width: 32px;
      .flex-none;
    }
  }
}
</style>
